export default __webpack_public_path__ + "static/media/bradesco.mtex.app.e80d1d57.jpeg";